import React from 'react';
import { Link } from 'react-router-dom';

import { INavigation } from '../../shared/types/catalog';

interface IBreadcrumbsItemProps {
  item: INavigation;
  index: number;
  arrayLength: number;
  catalogType: string;
}

export const BreadcrumbsItem: React.FC<IBreadcrumbsItemProps> = ({
  item,
  index,
  arrayLength,
  catalogType,
}) => {
  return (
    <React.Fragment key={item.id}>
      <div className="breadcrumbs__item--gray">/</div>
      {index === arrayLength - 1 ? (
        <div className="breadcrumbs__item--gray">{item.title}</div>
      ) : (
        <Link to={`/${catalogType}/${item.slug}`}>
          <div className="breadcrumbs__item--red">{item.title}</div>
        </Link>
      )}
    </React.Fragment>
  );
};
